var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('AppHeader'),_c('main',{staticClass:"home-page__main"},[_c('ScrollReveal',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var visible = ref.visible;
return [_c('HeroSection',{attrs:{"visible":visible}})]}}])}),_c('ScrollReveal',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var visible = ref.visible;
return [_c('HistoryAccordion',{attrs:{"visible":visible}})]}}])}),_c('ScrollReveal',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var visible = ref.visible;
return [_c('KnowledgeMapSection',{attrs:{"visible":visible}})]}}])}),_c('ScrollReveal',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var visible = ref.visible;
return [_c('RelationshipGraphSection',{attrs:{"visible":visible}})]}}])})],1),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }